<template>
    <div>
        <div class="ml-auto mr-0">
            <button @click="view_invoice = !view_invoice" v-if="!globalViewOption('UpdateInvoice')" type="button" class="btn btn-h btn-primary px-3 mb-4">
                <span>{{ view_invoice ? 'Editar' : 'Ver'}} factura</span>
            </button>
        </div>
        <div class="card" v-if="view_invoice">
            <div class="card-body">
                <billing :print="false"/>
            </div>
        </div>
        <div class="card" v-else>
            <div class="card-body">
                <generate :prevent="true" @end="view_invoice = true"/>
            </div>
        </div>
    </div>
</template>
<script>
import Generate from './invoice/Generate'
import Billing from './invoice/Billing'
export default {
    components: { Generate, Billing },
    props: {
        state: Number,
        invoice: {
            type: Object,
            default: null
        }
    },
    data(){
        return {
            view_invoice: true,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/forms/Invoice.vue